export const INPUT_MAXLENGTH = 250;
export const TEXTAREA_MAXLENGTH = 500;
